import { Post, postJSON } from "../utils/http.js"

export function getOrderList(query) {
  return postJSON("/api/order/orderList", query, { loading: true })
}

export function cancelOrder(query) {
  return Post("/api/order/orderCancel", query, { loading: true })
}
export function deleteOrder(query) {
  return Post("/api/order/delOrder", query, { loading: true })
}
export function buyAgain(query) {
  return Post("/api/cart/v20/buyAgain", query, { loading: true })
}

export function getOrderDetails(query, isLoading = true) {
  return postJSON("/api/order/orderDetail", query, { loading: isLoading })
}

export function getOrderEstampDetails(query) {
  return Post("/api/estamp/order/detail", query, { loading: true })
}

export function getCancelReason(query) {
  return Post("/api/order/cancelReason", query, { loading: true })
}
export function getRelatedOrderList(query) {
  return Post("/api/order/relatedOrderList", query, { loading: true })
}

export function cancelOrderAfterPaid(query) {
  return Post("/api/order/cancelAfterPaid", query, { loading: true })
}

export function getReceipt(query) {
  return Post("/api/order/receipt", query, { loading: true })
}

export function orderInfoAfterPay(query, isLoading = true) {
  return Post("/api/order/orderInfoAfterPay", query, { loading: isLoading })
}
